import * as classNames from "classnames";
import * as React from "react";
import { ShowTimeLight } from "source/app/presentation/MainPanel/Goals/DailyGoals/DailyGoal/TimeLight/ShowTimeLight";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import { GoalEditor } from "../../GoalEditor/GoalEditor";
import * as styles from "./DailyGoal.css";
import { DisplayStreak } from "./Streak/DisplayStreak";
import moment from "moment";
import { PostDailyGoalLink } from "./PostDailyGoalLink";
import { DailyGoalName } from "./DailyGoalName";
import { IDailyGoalProps } from "./IDailyGoalProps";
import { IDailyGoalState } from "./IDailyGoalState";
import { DailyGoalGoalIcon } from "./DailyGoalGoalIcon";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";

export class DailyGoal extends React.Component<
    IDailyGoalProps,
    IDailyGoalState
> {
    constructor(props: IDailyGoalProps) {
        super(props);

        this.state = {
            canPost: true,
        };
    }

    render() {
        const isGoalInDanger =
            moment().diff(this.props.latestDatapointTime, "days") >=
            this.props.goal.goalindangerdayslimit;

        var badStreakLength = this.props.goalStreakInfo?.badStreakLength;
        var hasGoodStreak = badStreakLength === 0;
        const { goalStreakInfo } = this.props;

        return (
            <span
                className={classNames(
                    dailyGoalGroupStyleClass,
                    {
                        [styles.isChecked]: this.props.isChecked,
                        [goalDangerStyleClass]: isGoalInDanger,
                        [goalGoodStyleClass]:
                            !isGoalInDanger && hasGoodStreak,
                        [goalNeutralStyleClass]:
                            !isGoalInDanger && !hasGoodStreak,
                        [reduceOpacityStyleClass]:
                            goalStreakInfo?.isFutureDailyGoal &&
                            goalStreakInfo?.badStreakLength !== 0,
                    }
                )}
            >
                <ShowTimeLight goal={this.props.goal} {...{ hasGoodStreak }} />
                <Hyperlink whenClicked={() => GoalEditor(this.props.goal)}>
                    <DailyGoalGoalIcon goal={this.props.goal} />
                    <DailyGoalName name={this.props.goal.name} />
                </Hyperlink>
                <PostDailyGoalLink
                    {...{
                        key: this.props.goal.id,
                        goal: this.props.goal,
                        streakMomentum: this.props.goalStreakInfo?.realMomentum,
                    }}
                />
                <DisplayStreak
                    goodStreakLength={
                        this.props.goalStreakInfo?.goodStreakLength
                    }
                    badStreakLength={badStreakLength}
                    maxGoodStreakLength={this.props.goal.goalindangerdayslimit}
                />
            </span>
        );
    }
}

export const goalInDangerDaysLimit = 6;

const reduceOpacityStyleClass = StyleClassAuto({ opacity: 0.3 });

const goalDangerStyleClass = StyleClassAuto({
    color: `coral`,
    background: `linear-gradient(90deg, hsl(10deg 50% 24% / 0) 0%, hsl(10deg 50% 24% / 0.48) 30%, hsl(8deg 36% 12% / 0.38) 50%, hsl(10deg 50% 24% / 0.48) 70%, hsl(10deg 50% 24% / 0) 100%)`,
    boxShadow: `inset 0 0 0 1px hsl(14deg 82% 60% / 0.16)`,
    ":hover": {
        background: `linear-gradient(90deg, hsl(10deg 52% 26% / 0) 0%, hsl(10deg 52% 26% / 0.56) 30%, hsl(8deg 40% 14% / 0.44) 50%, hsl(10deg 52% 26% / 0.56) 70%, hsl(10deg 52% 26% / 0) 100%)`,
        boxShadow: `inset 0 0 0 1px hsl(14deg 86% 64% / 0.2)`,
    },
});

const dailyGoalGroupStyleClass = StyleClassAuto({
    display: `block`,
    position: "relative",
    borderRadius: "4px",
    padding: "5px 8px",
    width: "min(90%, 540px)",
    boxSizing: "border-box",
    whiteSpace: "nowrap",
    boxShadow: `inset 0 1px 0 hsl(0deg 0% 100% / 0.04), 0 0 0 1px hsl(220deg 18% 6% / 0.16)`,
});

const goalNeutralStyleClass = StyleClassAuto({
    background: `linear-gradient(90deg, hsl(220deg 12% 18% / 0) 0%, hsl(220deg 12% 18% / 0.32) 30%, hsl(220deg 10% 10% / 0.18) 50%, hsl(220deg 12% 18% / 0.32) 70%, hsl(220deg 12% 18% / 0) 100%)`,
    ":hover": {
        background: `linear-gradient(90deg, hsl(198deg 28% 20% / 0) 0%, hsl(198deg 28% 20% / 0.34) 30%, hsl(220deg 12% 11% / 0.2) 50%, hsl(198deg 28% 20% / 0.34) 70%, hsl(198deg 28% 20% / 0) 100%)`,
    },
});

const goalGoodStyleClass = StyleClassAuto({
    background: `linear-gradient(90deg, hsl(92deg 52% 22% / 0) 0%, hsl(92deg 52% 22% / 0.42) 30%, hsl(136deg 36% 14% / 0.2) 50%, hsl(92deg 52% 22% / 0.42) 70%, hsl(92deg 52% 22% / 0) 100%)`,
    boxShadow: `inset 0 0 0 1px hsl(86deg 60% 56% / 0.1)`,
    ":hover": {
        background: `linear-gradient(90deg, hsl(92deg 54% 24% / 0) 0%, hsl(92deg 54% 24% / 0.46) 30%, hsl(136deg 38% 15% / 0.22) 50%, hsl(92deg 54% 24% / 0.46) 70%, hsl(92deg 54% 24% / 0) 100%)`,
    },
});
